import { isEmpty, mapValues, pick, trim } from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TextInput from '../ReusableComponents/TextInput/TextInput';

export default function CompanyFields(props) {
  const [form, setForm] = useState(
    pick(props.form, ['legal_name', 'company_name']),
  );
  const [errors, setErrors] = useState(mapValues(form, () => false));

  const onBlur = ({ target: { name, value } }) => {
    setErrors((s) => ({ ...s, [name]: isEmpty(value) }));
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    props.onChange(name, trim(value));
  };

  return (
    <div className="flex flex-col md:flex-row gap-4">
      <TextInput
        fullWidth
        required
        disabled={props.disabled}
        error={!!errors.legal_name || !!props.validationErrors?.legal_name}
        label={
          props.domestic ? 'Registered Legal Name' : 'Name of organization'
        }
        variant="outlined"
        onChange={onChange}
        onBlur={onBlur}
        name="legal_name"
        value={form.legal_name || ''}
        id="va-legal_name"
        autoComplete="no"
        formHelperText={props.validationErrors?.legal_name}
      />
      <TextInput
        fullWidth
        disabled={props.disabled}
        error={!!errors.company_name || !!props.validationErrors?.company_name}
        label={
          props.domestic ? 'Business Name if any' : 'Name of disregarded entity'
        }
        variant="outlined"
        onChange={onChange}
        onBlur={onBlur}
        name="company_name"
        value={form.company_name || ''}
        id="va-company-name"
        autoComplete="no"
        formHelperText={props.validationErrors?.company_name}
      />
    </div>
  );
}

CompanyFields.propTypes = {
  form: PropTypes.shape({
    legal_name: PropTypes.string,
    company_name: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  domestic: PropTypes.bool,
  validationErrors: PropTypes.shape({
    legal_name: PropTypes.string,
    company_name: PropTypes.string,
  }),
};
